module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAALVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADBoCg+AAAAD3RSTlMA/8BAPxDQMGDwgKBQ4LCjV5ZkAAAAzklEQVR4nGOgImB1gYIAFGE2QShIQBEuhAmLowgbwoSF0YQ3GwOBNYbwAhDFRa4wM8w2BDAgWZhdSVNQSAkOFAUnKRWATWcSFEBYziioAGXRXJg1g4GhDRgJaMJhgg0cgqkYwhsFJRoFpbGoBgJM1ayJgoJimGYzxAoKXsXiwEZBQQlMYQ6Q2Q0Ywo2CYokg5WjClYKpYYLTMYTZpwWwZgIDGt3KUgaGcDqGtwgs1bu4OCIJowCYMB+q8AOoMA+q8AGYNcWgJA8D5gjrKQQAIjsyeZDMakEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/delete.png
// module id = vmxF
// module chunks = 5